import type { ComponentProps } from 'react';
import { EditorProvider } from './EditorSdkProvider';
import { EditorToolsProvider } from './EditorToolsProvider';

export { useEditorTools } from './EditorToolsProvider';

export const EditorSdkProvider = ({
  children,
  ...props
}: ComponentProps<typeof EditorProvider>) => {
  return (
    <EditorProvider {...props}>
      <EditorToolsProvider>{children}</EditorToolsProvider>
    </EditorProvider>
  );
};
